const Modal = ({ isOpen, children }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-transparent  backdrop-blur-md z-50">
      {/* <div className="bg-white p-6 rounded-3xl shadow-xl w-[400px] border border-gray-200 shadow-gray-400 
                        transition-transform transform scale-95 hover:scale-100  ease-in-out">
          {children}
        </div> */}
      {children}
    </div>
  )
}

export default Modal
